// src/utils/authUtils.js
import { store } from '../redux/store';
import { logout } from '../redux/slices/authSlice';
import { clearWishlist } from '../redux/slices/wishlistSlice';
import Cookies from 'js-cookie';
import { toast } from 'react-toastify';

export const globalLogout = (error) => {
  const dispatch = store.dispatch;

  const TOKEN_ERROR_MESSAGES = [
    "Token expired",
    "Invalid or expired token",
    "Invalid token",
  ];

  const message = error?.response?.data?.message;

  if (TOKEN_ERROR_MESSAGES.includes(message)) {
    // ✅ Token problem → force logout
    dispatch(logout());
    dispatch(clearWishlist());
    Cookies.remove('ecom_user_token');

    window.location.href = '/login?message=session_expired';
  } else {
    // ❌ Not a token error → just log + toast
    console.error("API Error:", error);
    toast.error(message || "Something went wrong. Please try again.");
  }
};


// // src/utils/authUtils.js
// import { store } from '../redux/slices/wishlistSlice';
// import { logout } from '../redux/slices/authSlice';
// import { clearWishlist } from '../redux/slices/wishlistSlice';
// import Cookies from 'js-cookie';

// export const globalLogout = (isTokenExpired = false) => {
//   const dispatch = store.dispatch;
  
//   // Dispatch logout actions
//   dispatch(logout());
//   dispatch(clearWishlist());
  
//   // Remove token from cookies
//   Cookies.remove('ecom_user_token');
  
//   // Redirect to login page with message if token expired
//   if (isTokenExpired) {
//     window.location.href = '/login?message=session_expired';
//   } else {
//     window.location.href = '/login';
//   }
// };